


























import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "vue-router";
import router from "@/router/router";
import { COLOR_LIST_ROW_HOVER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

/** One figure: its label, the value as shown ("–" while unknown) and the screen a click opens. */
export interface AdminCockpitFigure {
  id: string;
  label: string;
  value: string;
  location: Location;
  /**
   * Nothing to do (an Aufgaben figure at 0): greyed, so the figures that need someone stand out and
   * the card can be scanned rather than read row by row. Still clickable.
   */
  quiet?: boolean;
}

export interface AdminCockpitCardData {
  key: string;
  title: string;
  /**
   * A caption below the figures, e.g. which clients a total covers and when it was counted. Below, not
   * under the title, so every card's figures start at the same height.
   */
  footnote?: string;
  color: string;
  figures: AdminCockpitFigure[];
  /** One of the card's sources failed; its figures read "–". */
  failed: boolean;
}

/**
 * A card of the IRES Admin cockpit: the normal cockpit card's look, laid out for large figures.
 *
 * Not `CockpitCard`, which the client's own cockpit uses: that one puts the count first, before the
 * label, and scrolls a fixed square. With figures in the tens of thousands the labels then start at a
 * different place on every row and the bottom rows hide. Here the label is on the left and the value
 * right-aligned in tabular digits, the common way to make numbers comparable at a glance. When the
 * cockpit fixes the card's height, only the figures scroll; title and footnote stay in view.
 */
@Component
export default class AdminCockpitCardComponent extends Vue {
  @Prop({ required: true }) card!: AdminCockpitCardData;

  /** Hover raises the row; in dark mode, where a shadow is invisible, it lightens instead. */
  rowStyle(hover: boolean): string {
    const background = hover ? themed("", COLOR_LIST_ROW_HOVER_DARK) : "";
    return background ? `background-color: ${background}` : "";
  }

  open(figure: AdminCockpitFigure) {
    router.push(figure.location);
  }
}
